export default "__VITE_ASSET__D$6DFXh3__"